import users from 'modules/core/store/collections/users'

import type Employee from 'modules/employees/store/models/Employee'

const employeeId = (userId: number | null, filteredEmployees: Employee[]) => {
  if (!userId) return null

  const employee = users.get(userId)?.employee

  if (!employee?.id) return null

  return filteredEmployees.some((e) => e.id === employee.id) ? employee?.id : null
}

export default employeeId
